module.exports = __webpack_public_path__ + "img/image6.1314915e.jpeg";